module.exports = __webpack_public_path__ + "img/cloth_g1_pants_02.7cba976d.svg";